import { PageHeader } from '@/components/layout/PageHeader';
import { ComingSoonState } from '@/components/ui/ComingSoonState';
import { SETTINGS_PATH, type SettingsMaster } from '@/config/settingsRegistry';

type Props = {
  master: SettingsMaster;
};

export function SettingsComingSoonPage({ master }: Props) {
  return (
    <div className="space-y-6">
      <PageHeader title={master.label} />
      <ComingSoonState
        title={master.label}
        description={master.description}
        backTo={SETTINGS_PATH}
        backLabel="All settings"
      />
    </div>
  );
}
